import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './customDialog.component.html',
  styleUrls: ['./customDialog.component.scss'],
})
export class CustomDialogComponent {
  title: string;
  modalType: string;
  formType: string;
  formData: [];
  dataTable: [];
  uuidData: string;
  showAnswers: boolean = false;

  constructor(public activeModal: NgbActiveModal) {}
}
